import React, {useEffect} from "react";
import {Spin} from 'antd';
import api from "../../../services/api";

import './style.scss';
import CircularProgress from "./CircularProgress";

const ApiSpinner  = ({children}: {children: React.ReactElement}) => {
    const [counter, setCounter] = React.useState(0)

    useEffect(()=> {
        // isteğin config'inde sessizYukleme: true varsa tam ekran gösterge açılmaz (26.10.2026: restoran adisyonuna ürün
        // ekleme / güncelleme / silme — ekranın kendi küçük "işlem sırada" göstergesi var, her dokunuşta ekran kararmasın)
        const sessiz = (c: any) => !!c?.sessizYukleme;
        api.interceptors.request.use(
            (config) => {
                if (!sessiz(config)) {
                    setCounter(r => r + 1)
                }
                return config
            },
            (error) => {
                return Promise.reject(error)
            }
        )

        api.interceptors.response.use((response) => {
                if (!sessiz(response?.config)) {
                    setCounter(r => r - 1)
                }
                return response
            },
            (error) => {
                if (!sessiz(error?.config)) {
                    setCounter(r => r - 1)
                }
                return Promise.reject(error)
            }
        )
    }, [])

    return (
        <Spin spinning={counter > 0} indicator={<CircularProgress/>} wrapperClassName='mino-api-sinner' >
            {children}
        </Spin>
    )
}

export default ApiSpinner;